// extracted by mini-css-extract-plugin
export default {"searchBar":"Search_searchBar__ZDfj3"};